document.addEventListener("turbo:load", () => {
  const callout = document.querySelector(".flash[role='alert']");
  if (!callout) {
    return;
  }
  setTimeout(() => {
    callout.setAttribute("tabindex", "0");
    callout.focus();
    callout.innerHTML += "&nbsp;";
  }, 500);
});
document.addEventListener("click", (event) => {
  const closeButton = event.target.closest("[data-alert-box] [data-close]");
  if (!closeButton) {
    return;
  }
  closeButton.closest("[data-alert-box]").remove();
});
